import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

// Site-wide head tags + GA4 loader. Nothing loads until an ID is configured in Admin → Settings.
export default function Trackers() {
  const settings = useSettings();
  const seo = settings?.seo || {};

  useEffect(() => {
    if (!seo.ga4Id || window.__ga4Loaded) return;
    window.__ga4Loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(seo.ga4Id)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", seo.ga4Id, { send_page_view: true });
  }, [seo.ga4Id]);

  return (
    <Helmet>
      {seo.googleVerification && <meta name="google-site-verification" content={seo.googleVerification} />}
      {seo.bingVerification && <meta name="msvalidate.01" content={seo.bingVerification} />}
    </Helmet>
  );
}
